export const createResendConfirmation = (body) => {
  return fetch('/api/v1/users/resend_confirmation', {
    method: 'POST',
    body: JSON.stringify(body),     
    headers: {'Content-Type': 'application/json', 'Accept': 'application/json' }
  })
  .then(res => res.json())
}